module.exports = __webpack_public_path__ + "img/reload.64cef303.svg";